class WhatsOnFilter {
    constructor(formSelector, cardSelector) {
        this.form = document.querySelector(formSelector);
        this.cards = [...document.querySelectorAll(cardSelector)];
        this.jsonData = this.getJsonData();
        this.currentIndex = 0; 
        this.cardsPerPage = 6; 
        this.paginationContainer = document.querySelector('.pagination'); 
        this.loadMoreButton = this.createLoadMoreButton();
        this.container = document.querySelector('.whats-on-feed'); 
        this.filteredCards = [];
        this.init();
    }

    init() {
        this.setupCheckboxListener();
        this.filterCards();
    }

    getJsonData() {
        const jsonDataElement = document.getElementById('json-data');
        return jsonDataElement ? JSON.parse(jsonDataElement.innerHTML) : [];
    }

    getSelectedLocations() {
        const checkboxes = this.form.querySelectorAll('input[name="location[]"]');
        return Array.from(checkboxes)
            .filter(checkbox => checkbox.checked)
            .map(checkbox => checkbox.value);
    }

    setupCheckboxListener() {
        const checkboxes = this.form.querySelectorAll('input[name="location[]"]');

        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', () => {
                this.currentIndex = 0; 
                this.filterCards();
            });
        });
    }

    getMatchingIds(selectedLocations) {
        return selectedLocations.length > 0
            ? this.jsonData.filter(event => event.event_location.some(location => selectedLocations.includes(location))).map(event => event.id)
            : this.jsonData.map(event => event.id);
    }

    filterCards() {

        const selectedLocations = this.getSelectedLocations();
        const matchingIds = this.getMatchingIds(selectedLocations);
        const filteredIds = new Set(matchingIds);

        // Reset container
        this.container.innerHTML = "";

        //Reset filtered cards
        this.filteredCards = [];

        //Filter, hide and append cards
        this.cards.forEach(card => {
            const cardId = card.getAttribute('data-id');
            if (filteredIds.size === 0 || filteredIds.has(cardId)) {
                card.style.display = 'none'
                this.container.append(card); 
                this.filteredCards.push(card);
            } 
        });

        this.displayInitalCards(this.filteredCards); 
    }

    displayInitalCards() {

        const filteredCardsCount = this.filteredCards.length;

        // Reset currentIndex if it exceeds filteredCardsCount
        if (this.currentIndex >= filteredCardsCount) {
            this.currentIndex = 0; 
        }

        // Show the initial card chunk
        const cardChunk = this.filteredCards.slice(this.currentIndex, this.currentIndex + this.cardsPerPage);
        cardChunk.forEach(card => {
            card.style.display = ''
        });

        this.currentIndex += this.cardsPerPage;

        this.updateLoadMoreButton(filteredCardsCount);
    }

    createLoadMoreButton() {
        const button = document.createElement('button');
        button.innerText = 'Load More';
        button.style.display = 'none';
        button.classList.add('btn', 'btn-black');
        button.addEventListener('click', () => this.loadMoreCards());
        
        // Append button to the pagination container
        this.paginationContainer.appendChild(button);
        return button;
    }

    updateLoadMoreButton(filteredCardsCount) {
        const remainingCardCount = filteredCardsCount - this.currentIndex;
        this.loadMoreButton.style.display = remainingCardCount > 0 ? 'block' : 'none'; 
    }

    loadMoreCards() {
        const selectedLocations = this.getSelectedLocations();
        const matchingIds = this.getMatchingIds(selectedLocations);
        
        const visibleCards = this.filteredCards.filter(card => card.style.display !== 'none'); 
        const totalVisible = visibleCards.length;
        const visibleIds = visibleCards.map(card => card.getAttribute('data-id'));
        const remainingCardIds = matchingIds.filter(id => !visibleIds.includes(id));

        const remainingCardCount = matchingIds.length - totalVisible;
        const cardChunkCount = Math.min(this.cardsPerPage, remainingCardCount); 

        // show the next cards
        for (let i = 0; i < cardChunkCount; i++) {
            const cardId = remainingCardIds[i];
            const cardElement = this.filteredCards.find(card => card.getAttribute('data-id') === cardId);
            if (cardElement) {
                cardElement.style.display = 'block';
            } else {
                console.log(`Card with ID ${cardId} not found`); 
            }
        }

        //update index
        this.currentIndex += cardChunkCount;

        //set load more button
        if (this.currentIndex >= matchingIds.length) {
            this.loadMoreButton.style.display = 'none'; 
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    if (document.body.classList.contains('page-template-whats-on')) {
        const formSelector = '#whats-on-filters'; 
        const cardSelector = '.card--event'; 
        new WhatsOnFilter(formSelector, cardSelector);
    } 
});

export default WhatsOnFilter;
